<template>
<div>
  <section class="white-bg title_container">
    <div class="title_container-p">
      <div class="container container-kernel">
        <slot name="title">
          <p class="title_page mb-0">
            <span class="h3">{{title}}</span>
          </p>
        </slot>
      </div>
    </div>
  </section>
  <div class="container container-kernel page">
    <slot></slot>
  </div>
  <back-to-top >
    <b-btn class="btn-icon btn-to-top"><i class="fa fa-chevron-up"></i></b-btn>
  </back-to-top>
</div>
</template>

<script>
export default {
  name: 'VueMain',
  props: ['title']
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/Main.vue